(function () {
    'use strict';
    angular
        .module('jotApp').factory('UserAlertService', UserAlertService)
        .factory('MaintenanceSettingsService', MaintenanceSettingsService)
        .factory('DomainAlertService', DomainAlertService);


    UserAlertService.$inject = ['$resource'];
    MaintenanceSettingsService.$inject = ['$resource'];
    DomainAlertService.$inject = ['$resource'];

    function UserAlertService($resource) {
        var resourceUrl = 'api/alerting-settings/:id';

        return $resource(resourceUrl, {}, {
            'getUserAlertsList': {method: 'GET', isArray: true},
            'getUserAlerts': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'userAlertingSettings': {
                url: 'api/alerting-settings/:alertType',
                method: 'POST',
                isArray: true
            },
            'getUserAlertingSettings': {
                url: 'api/alerting-settings/:alertType',
                method: 'GET',
                isArray: true
            },
            'checkUserAddAlertingSettings': {
                url: 'api/alerting-settings/:alertType/checkAdd',
                method: 'POST',
                isArray: true
            },
            'checkUserDeleteAlertingSettings': {
                url: 'api/alerting-settings/:id/checkDelete',
                method: 'GET',
                isArray: true
            },
            'deleteProvidedRequest': {
                url: 'api/alerting-settings/deleteProvidedRequest',
                method: 'POST',
            }
        });
    }

    function MaintenanceSettingsService($resource) {
        var resourceUrl = 'api/maintenance-setting/';

        return $resource(resourceUrl, {}, {
            'getMaintenanceListSetting': {method: 'GET', isArray: true},
            'getMaintenanceDetailSetting': {
                method: 'GET',
                transformResponse: function (data, headers, statusCode) {
                    if (statusCode === 200) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function DomainAlertService ($resource) {
        var resourceUrl =  'api/my-channel/:id';

        return $resource(resourceUrl, {}, {
            'getDomainAlertsList': { method: 'GET', isArray: true},
            'getDomainAlerts': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'userAlertSystem' : {
                method:'PUT' ,
                url:'api/my-channel-user'
            },
            'getUserAlertSystem' : {
                method:'GET' ,
                url:'api/my-channel-user/:user',
                isArray: true
            },
            'getSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/state'
            },
            'checkSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/status'
            },
            'sendSlackWelcome' : {
                method:'GET' ,
                url:'api/slack/integration/test'
            },
            'sendMailCode' : {
                method:'GET' ,
                url:'api/mail/integration?email=:email'
            },
            'checkMailCode' : {
                method:'GET' ,
                url:'api/mail/authorize?authorizationCode=:authorizationCode'
            },
            'checkTelegramCode' : {
                method:'GET' ,
                url:'api/telegram/authorize?authorizationCode=:authorizationCode'
            },
            'getAuthentications' : {
                method:'GET' ,
                url:'api/webhook/integration/authenticationType',
                isArray : true
            },
            'checkWebhook' : {
                method:'POST' ,
                url:'api/webhook/integration/test'
            },
            'saveWebhook' : {
                method:'GET' ,
                url:'api/webhook/integration/save'
            }
        });
    }
})();
